import { useEffect } from "react";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Portfolio } from "@/components/Portfolio";
import { WhyTyrell } from "@/components/WhyTyrell";
import { Process } from "@/components/Process";
import { Management } from "@/components/Management";
import { Development } from "@/components/Development";
import { Testimonials } from "@/components/Testimonials";
import { CtaSection } from "@/components/CtaSection";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  useEffect(() => {
    if (window.location.hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(window.location.hash);
        if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
        else el?.scrollIntoView({ behavior: "smooth" });
      }, 400);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <main>
      <Nav />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Portfolio />
      <WhyTyrell />
      <Process />
      <Management />
      <Development />
      <Testimonials />
      <CtaSection />
      <Contact />
      <Footer />
    </main>
  );
}
